export enum DevicesViewerFields {
  DEVICE_DESCRIPTION = 'deviceDescription',
  CALIBER = 'caliber',
  DEVICE_COMPLEMENT = 'deviceComplement',
  TOPOGRAPHY_DESCRIPTION = 'topographyDescription',
  SIDE = 'side',
  DEVICES_USED_QUANTITY = 'devicesUsedQuantity',
  HOURS_OF_PERMANENCE = 'hoursOfPermanence',
  TIMES_ATTEMPTED = 'timesAttempted',
  INSTALLATION_DATE = 'installationDate',
  SCHEDULED_END_DATE = 'scheduledEndDate',
  END_DATE = 'endDate',
  BANDAGE_SCHEDULE_REMOVAL = 'bandageScheduledRemoval',
  NOTES_DESCRIPTION = 'notesDescription',
  PROFESSIONAL_NAME = 'professionalName',
  BANDAGE_HOURS_OF_PERMANENCE = 'bandageHoursOfPermanence',
  RETIRE_REASON = 'retireReason',
}